namespace TabAurous.Production {
    export interface JobWorkIssueItemsForm {
        FromDeptId: Serenity.LookupEditor;
        BagNo: Serenity.StringEditor;
        SubBagNo: Serenity.IntegerEditor;
        Line_No: Serenity.StringEditor;
        OrderNo: Serenity.StringEditor;
        CustomerName: Serenity.StringEditor;
        TransDate: Serenity.DateEditor;
        VoucherNo: Serenity.StringEditor;
        ProductCode: Serenity.StringEditor;
        Attribute: Serenity.StringEditor;
        TreeId: Serenity.StringEditor;
        TreeItemId: Serenity.StringEditor;
        TreeNo: Serenity.StringEditor;
        FromPieces: Serenity.IntegerEditor;
        ProductId: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        FromWorkerId: Serenity.LookupEditor;
        FromWeight: WeightEditor;
        FromNetWeight: WeightEditor;
        KaratId: Serenity.LookupEditor;
        Purity: Serenity.DecimalEditor;
        PureWeight: WeightEditor;
        MetalColorId: Serenity.LookupEditor;
        ShapeId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        QualityId: Serenity.LookupEditor;
        StoneSizeId: StoneSizeLookup;
        SieveId: StoneSieveLookup;
        GroupSieveId: StoneSieveLookup;
        StoneCutId: Serenity.LookupEditor;
        StonePolishId: Serenity.LookupEditor;
        StoneSymmetryId: Serenity.LookupEditor;
        StoneFluorescenceId: Serenity.LookupEditor;
        StoneCuletId: Serenity.LookupEditor;
        StoneGirdleId: Serenity.LookupEditor;
        StoneTable: Serenity.StringEditor;
        StoneDepth: Serenity.StringEditor;
        Lab: Serenity.LookupEditor;
        CertificateNo: Serenity.StringEditor;
        Hallmark: Serenity.LookupEditor;
        BOMDetails: JobWorkIssueBOMEditor;
        NewBOMDetails: MaterialOutJobWork;
        CompanyId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
        RefVoucherId: Serenity.IntegerEditor;
        RefTransId: Serenity.StringEditor;
        RefTransItemId: Serenity.StringEditor;
        OrderTypeId: Serenity.IntegerEditor;
        OrderTransId: Serenity.IntegerEditor;
        OrderTransItemId: Serenity.IntegerEditor;
        UserId: Serenity.IntegerEditor;
        DepartmentId: Serenity.LookupEditor;
        Parts: Serenity.IntegerEditor;
    }

    export class JobWorkIssueItemsForm extends Serenity.PrefixedContext {
        static formKey = 'Production.JobWorkIssueItems';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!JobWorkIssueItemsForm.init)  {
                JobWorkIssueItemsForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DateEditor;
                var w4 = WeightEditor;
                var w5 = s.DecimalEditor;
                var w6 = StoneSizeLookup;
                var w7 = StoneSieveLookup;
                var w8 = JobWorkIssueBOMEditor;
                var w9 = MaterialOutJobWork;

                Q.initFormType(JobWorkIssueItemsForm, [
                    'FromDeptId', w0,
                    'BagNo', w1,
                    'SubBagNo', w2,
                    'Line_No', w1,
                    'OrderNo', w1,
                    'CustomerName', w1,
                    'TransDate', w3,
                    'VoucherNo', w1,
                    'ProductCode', w1,
                    'Attribute', w1,
                    'TreeId', w1,
                    'TreeItemId', w1,
                    'TreeNo', w1,
                    'FromPieces', w2,
                    'ProductId', w1,
                    'AttributeId', w1,
                    'FromWorkerId', w0,
                    'FromWeight', w4,
                    'FromNetWeight', w4,
                    'KaratId', w0,
                    'Purity', w5,
                    'PureWeight', w4,
                    'MetalColorId', w0,
                    'ShapeId', w0,
                    'StoneColorId', w0,
                    'QualityId', w0,
                    'StoneSizeId', w6,
                    'SieveId', w7,
                    'GroupSieveId', w7,
                    'StoneCutId', w0,
                    'StonePolishId', w0,
                    'StoneSymmetryId', w0,
                    'StoneFluorescenceId', w0,
                    'StoneCuletId', w0,
                    'StoneGirdleId', w0,
                    'StoneTable', w1,
                    'StoneDepth', w1,
                    'Lab', w0,
                    'CertificateNo', w1,
                    'Hallmark', w0,
                    'BOMDetails', w8,
                    'NewBOMDetails', w9,
                    'CompanyId', w2,
                    'FinancialYearId', w2,
                    'RefVoucherId', w2,
                    'RefTransId', w1,
                    'RefTransItemId', w1,
                    'OrderTypeId', w2,
                    'OrderTransId', w2,
                    'OrderTransItemId', w2,
                    'UserId', w2,
                    'DepartmentId', w0,
                    'Parts', w2
                ]);
            }
        }
    }
}
